import { dataMuteSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMuteSolid = /*#__PURE__*/createIcon(dataMuteSolid)
export default IconMuteSolid
